import { captureTextByPlaceholder } from 'js/helpers/capture-text-by-placeholder';
import React from 'react';

export const HighlightedText = ({
  className,
  text,
}: {
  className: string;
  text: string;
}): React.ReactElement => {
  const parts = captureTextByPlaceholder(text, 'highlight');
  const highlightedText: React.ReactElement[] = parts.map<React.ReactElement>(
    (part) => <React.Fragment key={part}>{part}</React.Fragment>
  );

  for (let index = 1; index < parts.length; index += 2) {
    const textToHighlight: string = parts[index];

    highlightedText[index] = (
      <span className={className} key={`${textToHighlight}-${index}`}>
        {textToHighlight}
      </span>
    );
  }

  return <>{highlightedText}</>;
};
